import type { RouteRecordRaw } from 'vue-router'

/**
 * Owner Payments self-serve onboarding.
 *
 * Lives under `brands/:brandId` so the brand comes from the URL rather than the
 * merchant's session: Olympus derives the tenant ACL from the brand, so a
 * session-derived guess would 403 anyone arriving at a brand they are not
 * currently viewing.
 *
 * No `meta.isPublic`, so an unauthenticated arrival goes to login and replays
 * afterwards; no `meta.authZ`, since authorization stays on the Olympus
 * endpoints; no `meta.title`, which would publish these to the command palette
 * where they have no location to act on.
 */
export const ownerPaymentsRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/OwnerPaymentsLocationsView.vue'),
    name: 'owner-payments.locations',
    path: 'owner-payments/switch',
  },
  {
    component: async () => import('../views/OwnerPaymentsLocationView.vue'),
    name: 'owner-payments.location',
    path: 'owner-payments/switch/:locationId',
    props: (route) => ({ locationId: route.params.locationId }),
  },
  // Its own route rather than a state inside the location view: `<router-view>`
  // is unkeyed, so "review next location" from within that view would reuse the
  // existing instance and leave the Stripe session pointed at the old location.
  {
    component: async () => import('../views/OwnerPaymentsLocationDoneView.vue'),
    name: 'owner-payments.location.done',
    path: 'owner-payments/switch/:locationId/done',
    props: (route) => ({ locationId: route.params.locationId }),
  },
  {
    component: async () => import('../views/OwnerPaymentsReadyView.vue'),
    name: 'owner-payments.ready',
    path: 'owner-payments/ready',
  },
]
